import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
    static targets = ["input", "message"];

    declare readonly inputTarget: HTMLInputElement;
    declare readonly messageTarget: HTMLElement;

    connect(): void {
        this.refresh();
    }

    refresh(): void {
        const isTooShort = this.inputTarget.value.length < this.inputTarget.minLength;
        this.messageTarget.hidden = !isTooShort;
        this.messageTarget.setAttribute("aria-hidden", isTooShort ? "false" : "true");
    }
}
